// src/lib/socket.js
import { io } from 'socket.io-client';

const URL =
  import.meta.env.VITE_SOCKET_URL ||
  import.meta.env.VITE_API_URL?.replace(/\/api\/?$/, '') ||
  (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:4000');

export const socket = io(URL, {
  autoConnect: false,
  // Read token lazily on each connect — avoids stale token after login
  auth: (cb) => cb({ token: localStorage.getItem('token') || '' }),
  transports: ['websocket', 'polling'],
});

// If token is rejected, clear session and send user to login
socket.on('connect_error', (err) => {
  if (err?.message === 'Token inválido' || err?.message === 'Token requerido') {
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    } catch {}
    if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
  }
});
